let html = `<div class="season-info selector">
    <div class="season-info__title">{name}</div>
    <div class="season-info__head">{head}</div>
    <div class="season-info__overview">{overview}</div>
</div>`

export default html